import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import styles from '../index.module.css';
import Logo from '../../../assets/images/brand/Uni_logo_landscape_white.png';
import ToggleIcon from '../../../assets/images/icons/toggle_icon.png';
import NormalUserRoutes from "../../../routes/NormalUserRoutes";

const UserSidebar = ({ isSidebarOpen, closeSidebar }) => {
    const location = useLocation(); 
    const slicedRoutes = NormalUserRoutes.slice(0, 1);

    useEffect(() => {
        document.addEventListener("mousedown", closeSidebar);
        return () => {
            document.removeEventListener("mousedown", closeSidebar);
        };
    }, []);

    return (
        <>
            <div className={`${styles.sideBarContainer} ${isSidebarOpen ? styles.showSidebar : styles.hideSidebar
                }`}>
                <div className={styles.sidebarLogo}>
                    <img src={ToggleIcon} className={styles.toggleBtn} alt="toggle" onClick={closeSidebar} />
                    <img src={Logo} alt="IBS College" className={styles.logoImage} />
                </div>
                <ul className={styles.sidebarMenu}>
                    {slicedRoutes.map((item, index) => (
                        <li
                            key={index}
                            className={location.pathname === `/user/${item.path}` ||
                                location.pathname.startsWith(`/user/${item.path}/`) ? styles.active : ""} // Add 'active' class
                        >
                            <Link to={`/user/${item.path}`} className={styles.linkText}>
                                <img src={location.pathname === `/user/${item.path}` ||
                                    location.pathname.startsWith(`/user/${item.path}/`) ? item.icon : item.inactiveIcon}
                                    className={styles.sidebarIcon} />
                                <span>{item.name}</span>
                            </Link>
                        </li>
                    ))}
                </ul>
            </div>
        </>
    );
};

export default UserSidebar;